import React, { useState } from 'react';
import {
    TableCell,
    TableRow,
    IconButton,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from '@mui/material';
import '../styles/month-report.scss';
import { Close } from '@mui/icons-material';
import { useStore } from 'effector-react';
import { $authUserData } from '../store/cards';
import { deleteSupportTask } from './api';

export function SupportTaskRow(props) {
    const authUserData = useStore($authUserData);
    const {
        task,
        setCategorySelectValue,
        setResponsibleSelectValue,
        setStatusSelectValue,
        setCustomerSelectValue,
        loadData
    } = props;
    const [background, setBackground] = useState(task.status.background_color);
    const [showDialogDelete, setShowDialogDelete] = useState(false);

    const handleCloseDialog = (event, dialogResult) => {
        if (dialogResult) {
            deleteSupportTask(task.id).then(data => loadData());
        }
        setShowDialogDelete(false);
    }

    return (
        <TableRow
            width={10}
            key={task.id}
            style={{ background: background }}
            onMouseEnter={() => { setBackground(task.status.background_color !== 'null' ? task.status.background_color + '4d' : '#0000000a') }}
            onMouseLeave={() => setBackground(task.status.background_color !== 'null' ? task.status.background_color : null)}
        >
            <TableCell align="center">
                {authUserData && authUserData.is_head_of_department
                    ? <IconButton onClick={() => setShowDialogDelete(true)} style={{ padding: 0 }}>
                        <Close style={{ fontSize: 20, color: 'red' }} />
                    </IconButton>
                    : null}

            </TableCell>
            <TableCell align="center">
                {
                    task.customer
                        ? <p
                            onClick={() => setCustomerSelectValue(task.customer.id)}
                            className='table-row__use-filter table-row__customer'
                            style={{
                                background: task.customer && task.customer.color ? task.customer.color + 'b3' : 'none',
                                border: task.customer && task.customer.color ? '1px solid ' + task.customer.color : 'none',
                            }}
                        >
                            {task.customer.name}
                        </p>
                        : null
                }
            </TableCell>
            <TableCell
                width={10}
                align="center"
                onClick={() => setCategorySelectValue(task.category.id)}
                className='table-row__use-filter'
            >
                {task.category.name}
            </TableCell>
            <TableCell width={50}>
                <a href={`https://bitrix.borauto.ru/company/personal/user/1835/tasks/task/view/${task.task_id}/`} target="_blank" rel="noreferrer">{task.task_id}</a>
            </TableCell>
            <TableCell width={'24%'} align="left">{task.title}</TableCell>
            <TableCell
                width={150}
                onClick={() => setResponsibleSelectValue(task.responsible_id)}
                className='table-row__use-filter'
            >
                {task.responsible_name}
            </TableCell>
            <TableCell width={10} align="center">{task.sp_count ?? (task.category?.default_volume).toFixed(2) ?? 0}</TableCell>
            <TableCell width={110} align="center">{task.formated_deadline}</TableCell>
            <TableCell width={10} align="center">{task.formated_closed_date}</TableCell>
            <TableCell width={10} align="center">{task.formated_completion_date}</TableCell>
            <TableCell
                width={140}
                align="center"
                onClick={() => setStatusSelectValue(task.status.id)}
                className='table-row__use-filter'
            >
                {task.status.name}
            </TableCell>
            <Dialog
                open={showDialogDelete}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Вы уверенны, что хотите удалить задачу?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(event) => handleCloseDialog(event, true)} color="primary">
                        Да
                    </Button>
                    <Button onClick={(event) => handleCloseDialog(event, false)} color="primary" autoFocus>
                        Нет
                    </Button>
                </DialogActions>
            </Dialog>
        </TableRow>
    )
}